import router from '@/router/index'
import { Record } from '@/api/Models/MessageList'
import APIRequest from '@/api'
import { showToast } from 'vant'
import { TabData } from '@/api/Models/AppTabs'
import i18n from '@/locales'
import { getPcUrl } from '@/utils/urlMapping'

function detailLink(type: number) {
  switch (type) {
    case 4:
    case 100:
    case 101:
    case 1300:
      return 'broadcastDetail'
    case 5:
    case 500:
      return 'trainingDetail'
    case 6:
    case 300:
      return 'ExamInfo'
    case 7:
    case 400:
      return 'surveyInfo'
    case 9:
    case 800:
      return 'communityDetail'
    case 10:
    case 700:
      return 'liveStreamTrans' // 跳转直播详情页，中转路由
    case 18:
    case 200:
      return 'courseDetail'
    case 19:
      return 'communityDetail'
    case 600: // CEO反馈详情页
      return 'CeoDetail'
    case 1200:
      return 'integral'
    case 1201: // 1201 类型 暂未上线 临时处理
      return 'Empty'
    case 1101: // 报名详情页
      return 'applyDetail'
    case 1301: // 自定义链接跳转
      return 'webview'
    case 203: // 课程详情页
    case 204:
      return 'course'
    case 303:
      return 'examFollowDetail'
    case 401:
      return 'surveyFollowDetail'
    case 503:
      return 'trainingFollowDetail'
    case 803:
      return 'comDetailLevel'
    case 802: // 帖子，文章，图册详情页
      return 'communityLevel'
    case 806: // 短视频详情页
      return 'rollVideo'
    case 1400: // 练习详情页
      return 'ExamPractiseInfo'
    case 1500: // 讲师详情页
      return 'lecturerDetail'
    case 1600: // 面授详情页
      return 'faceDetail'
    case 1700: // 培训确认单页面
      return 'signDetail'
    case 1501: // 面授
      return 'TeachDetail'
    case 1502: // 直播
      return 'TeachManageLive'
    case 1503: // 员工作业批阅
      return 'HomeWorkCriticism'
    case 1504: // 员工考试批阅
      return 'examReview'
    case 1505: // 作业批阅
      return 'HomeWorkDetail'
    case 1506: // 考试批阅
      return 'ExamViewListDetail'
    case 1800:
      return 'TeamStudyDetail'
    case 1900: // 勋章详情页
      return 'myMedalList'
  }
  return undefined
}

const handleLinks = (item: Record) => {
  console.log('----> open item', item)
  if (!item.isJumpApp) return
  const link = detailLink(item.jumpType)
  if (link) {
    // result
    if (link === 'courseDetail') {
      router.push({
        name: link,
        query: {
          id: item.jumpModuleId,
          courseId: '',
          courseType: 'courseWare',
          endingType: 0,
          channel: 0
        }
      })
    } else if (link === 'course') {
      router.push({
        name: 'courseDetail',
        query: {
          id: item.jumpModuleId,
          courseId: '',
          courseType: item.jumpType === 203 ? 'course' : 'courseWare',
          endingType: 0,
          channel: 0,
          topId: item.customTemplateId || ''
        }
      })
    } else if (link === 'examFollowDetail') {
      router.push({
        path: '/examDetail',
        query: {
          id: item.jumpModuleId,
          studyType: 2
        }
      })
    } else if (link === 'surveyFollowDetail') {
      router.push({
        path: '/surveyDetail',
        query: {
          id: item.jumpModuleId,
          studyType: 3
        }
      })
    } else if (link === 'trainingFollowDetail') {
      router.push({
        path: '/projectDetail',
        query: {
          id: item.jumpModuleId,
          studyType: 1
        }
      })
    } else if (link === 'broadcastDetail') {
      // broadcastDetail/727815044523360274?jumpType=100&topId=727815044523360274
      // jumpType=100&jumpId=727815044523360274&qrcode=accbb35bf1764118a9b4c2a689b7f76b&isShortUrl=true
      router.push({
        name: link,
        params: {
          id: item.jumpModuleId
        },
        query: {
          jumpType: item.jumpType,
          topId: item.customTemplateId || ''
        }
      })
    } else if (link === 'surveyInfo') {
      router.push({
        name: link,
        query: {
          investigationId: item.jumpModuleId
        }
      })
    } else if (link === 'ExamInfo') {
      router.push({
        name: link,
        query: {
          examId: item.jumpModuleId
        }
      })
    } else if (link === 'Empty') {
      router.push({
        name: link,
        query: {
          msg: '暂未上线' // 注意多语言翻译
        }
      })
    } else if (link === 'webview') {
      if (item.customerJumpLink) {
        // document.title = i18n.global.t('app_details')
        // router.push('/webview?url=' + encodeURIComponent(item.customerJumpLink))
        handleExternalUrl({ jumpUrl: item.customerJumpLink })
      }
    } else if (link === 'myMedalList') {
      router.push({
        name: 'MyMedalList'
      })
    } else if (link === 'comDetailLevel') {
      router.push({
        name: link,
        query: {
          id: item.jumpModuleId,
          topId: item.customTemplateId || ''
        }
      })
    } else if (link === 'communityLevel') {
      router.push({
        name: 'comDetailLevel',
        query: {
          id: item.jumpModuleId
        }
      })
    } else if (link === 'TeamStudyDetail') {
      router.push(`/teamStudyDetail?id=${item.jumpModuleId}&studyType=1&range`)
    } else {
      let query: {
        id: string
        practiseId?: string
        lecturerId?: string
        faceId?: string
        trainConfirmId?: string
        bizId?: string
        examId?: string
        submitRecordId?: string
        reviewStatus?: number
        bizType?: number
        messageType?: string
      } = { id: item.jumpModuleId }
      // 根据条件决定是否添加额外的参数
      if (item.jumpType === 1400) {
        query.practiseId = item.jumpModuleId
      }
      if (item.jumpType === 1500) {
        query.lecturerId = item.jumpModuleId
      }
      if (item.jumpType === 1501) {
        query.bizId = item.jumpModuleId
      }
      if (item.jumpType === 1502) {
        query.id = item.jumpModuleId
      }
      if (item.jumpType === 1503) {
        query.submitRecordId = item.jumpModuleId
        query.reviewStatus = 1
        query.messageType = 'message'
      }
      if (item.jumpType === 1504) {
        query.examId = item.jumpModuleId
      }
      if (item.jumpType === 1505) {
        query.bizId = item.jumpModuleId
        query.bizType = 2402
      }
      if (item.jumpType === 1506) {
        query.bizId = item.jumpModuleId
        query.bizType = 2401
      }
      if (item.jumpType === 1600) {
        query.faceId = item.jumpModuleId
      }
      if (item.jumpType === 1700) {
        query.trainConfirmId = item.jumpModuleId
      }
      router.push({
        name: link,
        query
      })
    }
  } else {
    if (item.jumpType === 3 || item.jumpType === 17) {
      // if (item.jumpModuleId && item.jumpModuleId.length > 0) {
      //   handleLinks(item.jumpModuleId, { innerWebview: true, replace })
      // }
    } else if (item.jumpType === 1 || item.jumpType === 2) {
      router.push({
        name: 'courseDetail',
        query: {
          id: item.jumpModuleId,
          fileType: item.jumpType - 1,
          endingType: 0,
          channel: 1
        }
      })
    } else if (item.jumpType === 21) {
      // router.push({
      //   name: 'shopIndexTab',
      //   query: {}
      // })
      router.replace('/shopIndexTab')
      // handleLinks(`sandstalk://shop_mall?id=${item.appJumpUrl}`, { replace })
    } else if (item.jumpType === 805) {
      APIRequest.Community.getCommunityBoardContent({
        id: item.jumpModuleId,
        loadingShow: '0'
      }).then((value) => {
        if (value.code === 0 && value.msg != null) {
          router.push({ path: '/empty', query: { msg: value.msg } })
        }
        if (value.data) {
          router.push({
            path: '/rollVideo',
            query: {
              sortType: 0,
              id: item.jumpModuleId,
              boardId: value.data.boardId,
              topId: item.customTemplateId
            }
          })
        }
      })
      return
    } else if (item.jumpType === 1202) {
      // const objParams = JSON.parse(item.jumpModuleId)
      // console.log('item.jumpModuleId===>', item.jumpModuleId)

      // 证书详情
      router.push({
        path: '/certificateDetail',
        query: {
          id: item.jumpModuleId
        }
      })
    }
  }
}

const getCommunityDetailType = async (localItem: Item) => {
  if (localItem.appJumpStatus === 19) {
    const { code, data } = await APIRequest.Community.getCommunityBoardDetail({
      id: localItem.appJumpUrl
    })
    if (code === 1) {
      // communityDetailType.value = data.type.toString()
      // item.value = localItem
    }
  }
}

interface Item {
  appJumpUrl: string
  appJumpStatus: number
}
const skipCommunityDetailScreen = async (item: Item) => {
  if (item.appJumpStatus === 19) {
    const { code, data } = await APIRequest.Community.getCommunityBoardDetail({
      id: item.appJumpUrl
    })
    if (code === 1) {
      router.push(`/communityDetail?id=${item.appJumpUrl}&type=${data.type}`)
    }
  }
}
const skipScreen = (item: Item) => {
  const jumpStatus = item.appJumpStatus
  const jumpId = item.appJumpUrl
  switch (jumpStatus) {
    case 1:
      router.push(`/courseDetail?id=${jumpId}&courseId=&courseType=course&endingType=0&channel=0`)
      break
    case 2:
      router.push(`/courseDetail?id=${jumpId}&courseId=&courseType=courseWare&endingType=0&channel=0`)
      break
    case 5:
      router.push(`/trainingDetail?id=${jumpId}`)
      break
    case 6:
      router.push(`/examInfo?examId=${jumpId}`)
      break
    case 7:
      router.push(`/surveyInfo?investigationId=${jumpId}&status=1`)
      break
    case 9:
      router.push(`/comDetailLevel?id=${jumpId}`)
      break
    case 12:
      router.push(`/myTraining`)
      break
    case 15:
      router.push(`/community`)
      break
    case 19:
      skipCommunityDetailScreen(item)
      break
    case 20:
      router.push(`/Check?id=${jumpId}`)
      break
    case 21:
      router.push(`/shopDetail?id=${jumpId}`)
      break
    case 22:
      router.push(`/shopIndex`)
      break
    case 29:
      router.push(`/merchantDetail?merchantDetailId=${jumpId}`)
      break
    case 31:
      window.location.href = `${getPcUrl()}knowledgeBase/list/${jumpId}`
      break
    case 32:
      window.location.href = `${getPcUrl()}knowledgeBase/article/${jumpId}`
      break
    case 100:
      router.push(`/trainingDetail?id=${jumpId}`)
      break
  }
}

const handleSandsShorUrl = async (jumpUrl: string) => {
  const shortUrl = jumpUrl.trim().split('/').pop() as string
  const { code, data } = await APIRequest.App.getShortURL({ shortUrl })
  if (code === 1) {
    // http://test-sands.jms.com/download/unsupported.html?jumpType=19&jumpId=526616020916375596&clientType=web&
    if (typeof data === 'string') {
      const paramStr = data.split('?')[1]
      const localItem: Item = {} as Item
      if (paramStr) {
        paramStr.split('&').forEach((value) => {
          const arr = value.split('=')
          if (arr.length === 2) {
            if (arr[0] === 'jumpId') {
              localItem.appJumpUrl = arr[1]
            } else if (arr[0] === 'jumpType') {
              localItem.appJumpStatus = parseInt(arr[1])
            }
          }
        })
        skipScreen(localItem)
      }
    } else {
      // {"code": 0, "errorMsg": "找不到长链接"}
      // item.value = { appJumpStatus: 3, appJumpUrl: '' }
    }
  }
}

export const isWeimobMall = (item: TabData) => {
  const { defaultCode: code, jumpUrl } = item
  if (!code && jumpUrl) {
    if (jumpUrl.startsWith('http') && jumpUrl.indexOf('weimob.com') > 0) {
      return true
    }
  }
  return false
}
interface TMenuItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
}
export const isWeimobMallForMenu = (item: TMenuItem) => {
  const { dataJumpType, dataJumpUrl } = item
  if (dataJumpType === 3 && dataJumpUrl) {
    if (dataJumpUrl.startsWith('http') && dataJumpUrl.indexOf('weimob.com') > 0) {
      return true
    }
  }
  return false
}

export const skipExternalMall = async (url?: string) => {
  if (!url) {
    return
  }
  const res = await APIRequest.App.postWeimobLogin({})
  console.log(res)
  if (res.code === 1) {
    const data = res.data
    if (!data.appTicket) {
      showToast('登录授权失败')
      return
    }
    const joinChar = url.indexOf('?') > 0 ? '&' : '?'
    const jumpUrl = `${url}${joinChar}appTicket=${data.appTicket}&appClientId=${data.appClientId}`
    location.href = jumpUrl
  }
}

interface Params {
  jumpUrl: string
  title?: string
}
const handleExternalUrl = async ({ jumpUrl }: Params) => {
  if (!jumpUrl) {
    return
  }
  const str =
    process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'uat' ? 'share.sandstalk.com/s' : 'sands-system/s'
  if (jumpUrl?.indexOf(str) > -1) {
    handleSandsShorUrl(jumpUrl)
  } else {
    if (jumpUrl.startsWith('http') && jumpUrl.indexOf('weimob.com') > 0) {
      skipExternalMall(jumpUrl)
    } else {
      if (jumpUrl.startsWith('http') && jumpUrl.indexOf('douyin.com') > -1) {
        window.location.href = jumpUrl
      } else {
        // 解决跳飞书问卷多了title提交失败的问题,去掉title
        const newUrl = `${encodeURIComponent(jumpUrl)}`
        window.location.href = `${decodeURIComponent(newUrl)}`
      }
    }
  }
}

export { handleLinks, handleExternalUrl }
